import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/spinner.less';
const Spinner = ({ className, style }) => {
    return (_jsxs("div", Object.assign({ className: 'ajax-spinner ' + className, style: style }, { children: [_jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) }), _jsx("div", { children: _jsx("div", {}) })] })));
};
Spinner.defaultProps = {
    className: '',
    style: null,
};
export default Spinner;
